var rmUtil = require("../rmlibrary_old/util");
var PDFNode = require("./node");
var PDFBlockNode = require("./block");
var StyleManager = require("../style-manager");
function PDFTableCellNode() {
    PDFBlockNode.apply(this, arguments);
    var colSpan = Number(this.originalNode.getAttribute("colspan"));
    if (!isNaN(colSpan))
        this.colSpan = colSpan;
    var rowSpan = Number(this.originalNode.getAttribute("rowspan"));
    if (!isNaN(rowSpan))
        this.rowSpan = rowSpan;
    if (this.originalNode.hasAttribute("data-pdf-scope")) {
        this.scope = this.originalNode.getAttribute("data-pdf-scope").toLowerCase();
    }
    else if (this.originalNode.hasAttribute("scope")) {
        this.scope = this.originalNode.getAttribute("scope").toLowerCase();
    }
}
rmUtil.inherits(PDFTableCellNode, PDFBlockNode);
PDFTableCellNode.prototype._getOptions = function () {
    var ret = PDFBlockNode.prototype._getOptions.call(this);
    ret.verticalAlign = this.computedStyles.verticalAlign;
    if (this.colSpan)
        ret.colSpan = this.colSpan;
    if (this.rowSpan)
        ret.rowSpan = this.rowSpan;
    if (this.scope)
        ret.scope = this.scope;
    return ret;
};
PDFTableCellNode.prototype.generate = function (pdf) {
    return pdf.td(this._getOptions(), this.children.map(function (child) {
        return child.generate(pdf);
    }));
};
function PDFTableRowNode() {
    PDFNode.apply(this, arguments);
    this.children = [];
}
rmUtil.inherits(PDFTableRowNode, PDFNode);
PDFTableRowNode.prototype.setChildren = function (children) {
    this.children = [];
    var that = this;
    children.forEach(function (child) {
        if (child instanceof PDFTableCellNode)
            that.children.push(child);
    });
};
PDFTableRowNode.prototype.generate = function (pdf) {
    return this.children.map(function (child) {
        return child.generate(pdf);
    });
};
function PDFTableRowGroupNode() {
    PDFNode.apply(this, arguments);
    this.isHeader = this.styles.display === "table-header-group";
    this.children = [];
}
rmUtil.inherits(PDFTableRowGroupNode, PDFNode);
PDFTableRowGroupNode.prototype.setChildren = function (children) {
    this.children = [];
    var that = this;
    children.forEach(function (child) {
        if (child instanceof PDFTableRowNode)
            that.children.push(child);
    });
};
function PDFTableNode() {
    PDFNode.apply(this, arguments);
}
rmUtil.inherits(PDFTableNode, PDFNode);
PDFTableNode.Row = PDFTableRowNode;
PDFTableNode.RowGroup = PDFTableRowGroupNode;
PDFTableNode.Cell = PDFTableCellNode;
PDFTableNode.prototype.setChildren = function (children) {
    this.children = [];
    var that = this;
    children.map(function (child) {
        if (child instanceof PDFTableRowGroupNode) {
            if (child.isHeader) {
                that.headerRows = child.children.length;
            }
            child.children.forEach(function (row) {
                that.children.push(row);
                row.parentElement = that;
            });
        }
        if (child instanceof PDFTableRowNode)
            that.children.push(child);
    });
};
PDFTableNode.prototype.generate = function (pdf) {
    if (!this.children || this.children.length === 0)
        return pdf.block({}, []);
    var columns = StyleManager.getColumnWidths(this.children[0].children.map(function (cell) {
        return cell.styles.width || "1fr";
    })).map(function (column) {
        if (column.unit === "px") {
            return {
                value: StyleManager.pxToPt(column.value),
                unit: "pt",
            };
        }
        return column;
    });
    var children = this.children.map(function (child) {
        return child.generate(pdf);
    });
    // console.log(children);
    return pdf.table({ columns: columns, headerRows: this.headerRows || 0, role: this.computedStyles.role }, children);
};
module.exports = PDFTableNode;
//# sourceMappingURL=module.js.map